import { AxiosConfig } from './axiosConfig';

/**
 * Preenche um html input do tipo select com os usuários associados ao cliente selecionado.
 *
 * É necessário ter dois select um com os clientes e outro vazio que receberá os usuários do cliente selecionado.
 * O input select dos clientes deve ter a classe "cliente-selecionado" e o input select dos usuários deve
 * ter o id "select2-popular-usuarios".
 *
 * Quando a página for recarregada, se o campo select com os clientes manter um valor selecionado, o campo select com
 * os usuários sera repopulado. Adicone um input do tipo hidden, igual ao exemplo abaixo, para armazenar o
 * usuário selecionado.
 *
 * <input type="hidden" id="usuario-selecionado" name="usuario-selecionado" value="{{ old('usuario_id') }}">
 */
(function () {
    const select2ClienteSelecionado = $('#cliente_id');
    const select2PopularUsuarios    = $('#select2-popular-usuarios');
    if (select2ClienteSelecionado.length === 0 || select2PopularUsuarios.length === 0) {
        return;
    }

    const idClienteSelecionado = parseInt(select2ClienteSelecionado.val());
    if (Number.isInteger(idClienteSelecionado)) {
        _popularCampoSelect(idClienteSelecionado);
    }

    select2ClienteSelecionado.on('select2:select', function (evento) {
        const objetoResposta = evento.params.data;
        if (objetoResposta.id) {
            _popularCampoSelect(objetoResposta.id);
        }
    });

    /**
     * Popula o campo select com os usuários do cliente selecionado.
     *
     * @param {number} clienteId
     * @return {void}
     */
    function _popularCampoSelect (clienteId) {
        const axios = (new AxiosConfig()).instanciaAxios();

        axios.get(_montarUrlConsulta(clienteId))
        .then((response) => {
            let arrayUsuarios = [{id: '', text: 'Selecione um usuário'}];
            if (Array.isArray(response.data) && response.data.length > 0) {
                response.data.forEach((usuario) => {
                    arrayUsuarios.push({id: usuario.id, text: usuario.nome});
                });
            }

            select2PopularUsuarios.html(null);
            select2PopularUsuarios.select2({
                data: arrayUsuarios,
            });

            const usuarioSelecionado = parseInt($('#usuario-selecionado').val());
            if (Number.isInteger(usuarioSelecionado)) {
                select2PopularUsuarios.val(usuarioSelecionado).trigger('change');
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

     /**
      * Url para consultar os usuários associados ao cliente selecionado.
      *
      * @param {number} clienteId
      * @return {string}
     */
     function _montarUrlConsulta (clienteId) {
        const urlSistema  = `${window.location.protocol}//${window.location.host}/clientes/${clienteId}/usuarios/json`;
        const camposBusca = 'campos[usuario]=id,nome';
        let filtroBusca   = `ativo='A'&qtdRegistros=1000`;

        return `${urlSistema}?${camposBusca}&${filtroBusca}`;
    }
})();
